import { render } from "./noUser.vue?vue&type=template&id=f8828f14"
import script from "./noUser.vue?vue&type=script&lang=js"
export * from "./noUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__